import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-5, chart, analytics"} maskId="square-filled-radius-0-stroke-1-IconTrending5"><path fillRule="evenodd" clipRule="evenodd" d="M4 3V16.1054L9.34375 10.7616L12 13.4179L17.3125 8.10539L20.1446 10.9375L19.4375 11.6446L17.3125 9.51961L12 14.8321L9.34375 12.1759L4 17.5196V20H21V21H3V3H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending5;
